/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Detail_User_IdInputs */

const en_audit_detail_user_id = /** @type {(inputs: Audit_Detail_User_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User ID`)
};

const pt_br2_audit_detail_user_id = /** @type {(inputs: Audit_Detail_User_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID do usuário`)
};

/**
* | output |
* | --- |
* | "User ID" |
*
* @param {Audit_Detail_User_IdInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_detail_user_id = /** @type {((inputs?: Audit_Detail_User_IdInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Detail_User_IdInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_detail_user_id(inputs)
	return pt_br2_audit_detail_user_id(inputs)
});